import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "status-card__icon",
  "aria-hidden": "true"
}
const _hoisted_2 = ["xlink:href"]
const _hoisted_3 = {
  key: 0,
  class: "status-card__title"
}
const _hoisted_4 = {
  key: 1,
  class: "status-card__content"
}
const _hoisted_5 = { class: "status-card__message" }

import { PropType, ref, onMounted } from 'vue'
import type { TravelInfoPod } from './../../types'
import { StatusColour } from './../../types/enums'
import { getCurrentCulture } from './../../utilities/culture-helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'TravelInfoPod',
  props: {
  travelInfo: {
    type: Object as PropType<TravelInfoPod>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const statusThemeClass = ref<string>()
const statusThemeIcon = ref<string>()
const { cultureShortCode } = getCurrentCulture()

onMounted(() => {
  switch (props.travelInfo.statusColour) {
    default:
      break
    case StatusColour.Green:
      statusThemeIcon.value = '#svg-check'
      statusThemeClass.value = 'status-card--success'
      break
    case StatusColour.Amber:
      statusThemeIcon.value = '#svg-warning'
      statusThemeClass.value = 'status-card--warning'
      break
    case StatusColour.Red:
      statusThemeIcon.value = '#svg-alert'
      statusThemeClass.value = 'status-card--danger'
      break
  }
})

return (_ctx: any,_cache: any) => {
  return (__props.travelInfo.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['status-card', statusThemeClass.value])
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_1, [
          _createElementVNode("use", { "xlink:href": statusThemeIcon.value }, null, 8 /* PROPS */, _hoisted_2)
        ])),
        (__props.travelInfo.title[_unref(cultureShortCode)])
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.travelInfo.title[_unref(cultureShortCode)]), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (__props.travelInfo.status[_unref(cultureShortCode)])
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.travelInfo.status[_unref(cultureShortCode)]), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (__props.travelInfo.messages)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(__props.travelInfo.messages, (msg) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(msg[_unref(cultureShortCode)]), 1 /* TEXT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}
}

})